import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserComponent } from './user/user.component';
import { FactsComponent } from './facts/facts.component';
import { NoticeTextComponent } from './notice/notice.component';
import { DemoSettingsComponent } from './demo/demosettings.component';
import { AgendaDictComponent } from './dictionary/agenda-dict.component';
import { AuditComponent } from './audit/audit.component';
import { AppraiserComponent } from './assessor/appraiser/appraiser.component';
import { AssessorDictComponent } from './assessor/dictionary/assessor-dict.component';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import {ConfirmationService} from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { OrderListModule } from 'primeng/orderlist';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PickListModule } from 'primeng/picklist';
import { CookieService } from 'ngx-cookie-service';

import { LoginRouteGuard} from 'src/app/login-route-guard';
import {MessagesModule} from "primeng/messages";


@NgModule({
  imports: [
    CommonModule,
    TableModule,
    FormsModule,
    ToastModule,
    ConfirmDialogModule,
    OrderListModule,
    ProgressSpinnerModule,
    RouterModule.forChild([
      {path: 'user', component: UserComponent, canActivate: [LoginRouteGuard]},
      {path: 'facts', component: FactsComponent, canActivate: [LoginRouteGuard]},
      {path: 'notices', component: NoticeTextComponent, canActivate: [LoginRouteGuard]},
      {path: 'demo', component: DemoSettingsComponent, canActivate: [LoginRouteGuard]},
      {path: 'agendaorder', component: AgendaDictComponent, canActivate: [LoginRouteGuard]},
      {path: 'audit', component: AuditComponent, canActivate: [LoginRouteGuard]},
      {path: 'appraiser', component: AppraiserComponent, canActivate: [LoginRouteGuard]},
      {path: 'assessor-dict', component: AssessorDictComponent, canActivate: [LoginRouteGuard] }
    ]),
    MessagesModule,
    PickListModule
  ],
  providers: [
    MessageService,
    ConfirmationService,
    CookieService,
  ],

  declarations: [
    UserComponent,
    FactsComponent,
    NoticeTextComponent,
    DemoSettingsComponent,
    AgendaDictComponent,
    AuditComponent,
    AppraiserComponent,
    AssessorDictComponent
  ]
})
export class SystemModule {}
